import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mhome/ui";

const CircadianDeleteDialog = ({ open, onClose, onConfirm, widgetName }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirm-dialog-title"
      aria-describedby="delete-confirm-dialog-description"
    >
      <DialogTitle id="delete-confirm-dialog-title">
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-confirm-dialog-description">
          Are you sure you want to delete the circadian schedule &quot;
          {widgetName}&quot;?
          <br />
          <br />
          All the automations related to this circadian schedule will stop
          working.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          style={{ boxShadow: "none" }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CircadianDeleteDialog;
